import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScrollMemoryService {
  private static readonly AUTO_SCROLL_CAPTURE_THRESHOLD = 200;
  private static readonly AUTO_SCROLL_CAPTURE_WINDOW_MS = 250;

  private readonly savedHomeScrollTop = signal(0);
  private readonly savedHomeVisibleTournamentGroupCount = signal<number | null>(null);
  private previousHomeScrollTop = 0;
  private lastHomeScrollTop = 0;
  private lastHomeScrollTimestamp = 0;

  rememberHomeScrollPosition(top: number): void {
    this.previousHomeScrollTop = this.lastHomeScrollTop;
    this.lastHomeScrollTop = top;
    this.lastHomeScrollTimestamp = performance.now();
  }

  captureHomeScrollPosition(): void {
    const scrollTop = window.scrollY;
    const recentScrollTop = Math.max(this.lastHomeScrollTop, this.previousHomeScrollTop);
    const shouldKeepRecentScrollTop =
      recentScrollTop - scrollTop >= ScrollMemoryService.AUTO_SCROLL_CAPTURE_THRESHOLD &&
      performance.now() - this.lastHomeScrollTimestamp <= ScrollMemoryService.AUTO_SCROLL_CAPTURE_WINDOW_MS;

    this.savedHomeScrollTop.set(shouldKeepRecentScrollTop ? recentScrollTop : scrollTop);
  }

  saveHomeVisibleTournamentGroupCount(count: number): void {
    this.savedHomeVisibleTournamentGroupCount.set(count);
  }

  consumeHomeVisibleTournamentGroupCount(): number | null {
    const count = this.savedHomeVisibleTournamentGroupCount();
    this.savedHomeVisibleTournamentGroupCount.set(null);
    return count;
  }

  scrollToTop(): void {
    this.scheduleWindowScroll(0);
  }

  restoreHomeScrollPosition(): void {
    const scrollTop = this.savedHomeScrollTop();
    this.savedHomeScrollTop.set(0);
    this.scheduleWindowScroll(scrollTop);
  }

  private scheduleWindowScroll(top: number): void {
    let attempts = 0;
    const syncScroll = () => {
      window.scrollTo({ top, behavior: 'auto' });
      attempts += 1;

      if (attempts < 3 && Math.abs(window.scrollY - top) > 1) {
        window.requestAnimationFrame(syncScroll);
      }
    };

    window.requestAnimationFrame(syncScroll);
  }
}
